// src/utils/imageFiles.ts
import type { CSSProperties } from "react";

export interface FilteredImageFiles {
  images: File[];
  rejectedCount: number;
}

/** 仅保留 type 以 "image/" 开头的文件；其余计入 rejectedCount。 */
export function filterImageFiles(files: File[]): FilteredImageFiles {
  const images = files.filter((f) => f.type.startsWith("image/"));
  return { images, rejectedCount: files.length - images.length };
}

/** 从 DataTransfer（拖拽 `e.dataTransfer` 或粘贴 `e.clipboardData`，二者皆为 DataTransfer）
 *  取 File 列表。优先 `.files`；为空时回退 `.items`（截图、网页复制的图片在不少浏览器里
 *  只出现在 items：kind === "file" + getAsFile()）。拖拽路径 `.files` 一般非空，直接命中。 */
export function getFilesFromDataTransfer(dt: DataTransfer | null | undefined): File[] {
  if (!dt) return [];
  const fromFiles = Array.from(dt.files ?? []);
  if (fromFiles.length > 0) return fromFiles;
  const items = dt.items ? Array.from(dt.items) : [];
  return items
    .filter((it) => it.kind === "file")
    .map((it) => it.getAsFile())
    .filter((f): f is File => f != null);
}

/** isOver 时返回高亮样式片段，供各上传位合并进自身 style。
 *  以 longhand 覆盖各站点 border 简写的颜色/线型，保留其 border 宽度。 */
export function getDropHighlightStyle(isOver: boolean): CSSProperties {
  if (!isOver) return {};
  return {
    borderStyle: "solid",
    borderColor: "var(--theme-scene)",
    background: "color-mix(in srgb, var(--theme-scene) 8%, transparent)",
  };
}
